import React from 'react'

export default function ComparativeAnalytics() {
  return (
    <div>ComparativeAnalytics</div>
  )
}
